import React from 'react';

export default React.createContext({
  showAmiOperations: false,
  canPerformAmiOperations: false,
  showCustomLineItems: null,
  onQuoteProductConfigurationUpdate: null,
  onQuoteUpdate: null,
  goBackToStep2: null,
  getQuoteDealerBranch: null,
  getQuoteCarrierMachines: null,
  setQuoteCarrierMachines: null,
});
